import content from 'content';
import { StepMetadata } from 'interfaces/store';
import { TransactionSteps } from 'interfaces/transaction';

export type Values = Pick<TransactionSteps, 'smallSite'>;

const metadata: StepMetadata = {
  id: 'small-site',
  title: content('page-title'),
  stepName: 'Your worksite'
};

export default metadata;
